import { Box, IconButton, Modal, Typography } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import React from 'react';

interface PropsModalDp {
	open: boolean;
	title?: string;
	children: React.ReactNode;
	onClose: () => void;
}
export const DpModal: React.FC<PropsModalDp> = ({ open, title, children, onClose }) => (
	<Modal sx={{ padding: 0 }} open={open} onClose={onClose}>
		<Box
			sx={{
				backgroundColor: 'white',
				width: '661px',
				height: 'auto',
				maxHeight: '30vw',
				overflow: 'auto',
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				borderRadius: '6px',
				padding: '25.5px 30px',
			}}
		>
			{title ? (
				<Typography
					sx={{
						textAlign: 'left',
						font: ' normal normal 800 24px/33px Open Sans',
						marginBottom: '16px',
					}}
					variant="h6"
				>
					{title}
				</Typography>
			) : null}

			<IconButton
				color="inherit"
				onClick={onClose}
				sx={{
					position: 'absolute',
					right: '15px',
					top: '15px',
					'&:hover': {
						backgroundColor: 'transparent',
						color: 'inherit',
					},
				}}
			>
				<ClearIcon color="inherit" fontSize="inherit" />
			</IconButton>

			{children}
		</Box>
	</Modal>
);
